// extracted by mini-css-extract-plugin
export var active = "ProductDetails-module--active--39765";
export var activeStickyTabContainer = "ProductDetails-module--activeStickyTabContainer--e4605";
export var addToCartButton = "ProductDetails-module--addToCartButton--12995";
export var addToCartHeader = "ProductDetails-module--addToCartHeader--36e83";
export var adjustItem = "ProductDetails-module--adjustItem--80f6d";
export var afterpayIconContainer = "ProductDetails-module--afterpayIconContainer--3bb6a";
export var autoShipContainer = "ProductDetails-module--autoShipContainer--084f1";
export var border = "ProductDetails-module--border--e9789";
export var brandLogoContainer = "ProductDetails-module--brandLogoContainer--cda81";
export var checkoutContainer = "ProductDetails-module--checkoutContainer--a3ad9";
export var checkoutContent = "ProductDetails-module--checkoutContent--5fdf2";
export var clickIconContainer = "ProductDetails-module--clickIconContainer--62f85";
export var collectContainer = "ProductDetails-module--collectContainer--905c0";
export var collectIconsContainer = "ProductDetails-module--collectIconsContainer--be32e";
export var completeTheLook = "ProductDetails-module--completeTheLook--505e6";
export var descriptionContainer = "ProductDetails-module--descriptionContainer--d4529";
export var designName = "ProductDetails-module--designName--2f7ef";
export var elseButton = "ProductDetails-module--elseButton--0862b";
export var fastCheckoutButtonContainer = "ProductDetails-module--fastCheckoutButtonContainer--cf5a7";
export var goButton = "ProductDetails-module--goButton--ad3ad";
export var hidePricing = "ProductDetails-module--hidePricing--6f0d2";
export var inventoryCheckContainer = "ProductDetails-module--inventoryCheckContainer--fab9a";
export var isCold = "ProductDetails-module--isCold--c7700";
export var isMedication = "ProductDetails-module--isMedication--3a9df";
export var klarnaIconContainer = "ProductDetails-module--klarnaIconContainer--4da84";
export var label = "ProductDetails-module--label--38667";
export var maxQtyMessage = "ProductDetails-module--maxQtyMessage--2f8e7";
export var mobileFulfillmentContainer = "ProductDetails-module--mobileFulfillmentContainer--fe5db";
export var mobileProductImageContainer = "ProductDetails-module--mobileProductImageContainer--7345e";
export var mobileShippingContainer = "ProductDetails-module--mobileShippingContainer--88d98";
export var noAutoShip = "ProductDetails-module--noAutoShip--05a6c";
export var noReviews = "ProductDetails-module--noReviews--03b49";
export var onSaleTag = "ProductDetails-module--onSaleTag--0855b";
export var option = "ProductDetails-module--option--5a3ce";
export var optionContainer = "ProductDetails-module--optionContainer--ce94f";
export var optionsTitle = "ProductDetails-module--optionsTitle--5642f";
export var outOfStock = "ProductDetails-module--outOfStock--09a5b";
export var outOfStockMobile = "ProductDetails-module--outOfStockMobile--168e7";
export var paymentOptions = "ProductDetails-module--paymentOptions--e7a56";
export var paypalColorIconContainer = "ProductDetails-module--paypalColorIconContainer--ba854";
export var poContainer = "ProductDetails-module--poContainer--2bce6";
export var postCode = "ProductDetails-module--postCode--c25df";
export var postcodeContainer = "ProductDetails-module--postcodeContainer--ec052";
export var preorderDetail = "ProductDetails-module--preorderDetail--680fa";
export var price = "ProductDetails-module--price--bd61c";
export var priceDetails = "ProductDetails-module--priceDetails--c06df";
export var prices = "ProductDetails-module--prices--1ffa6";
export var productDescription = "ProductDetails-module--productDescription--00950";
export var productDetails = "ProductDetails-module--productDetails--b3c3c";
export var productMessage = "ProductDetails-module--productMessage--c7309";
export var productPrice = "ProductDetails-module--productPrice--7ef22";
export var productQtyFav = "ProductDetails-module--productQtyFav--a280b";
export var productShopBtn = "ProductDetails-module--productShopBtn--05ec5";
export var productTitleSticky = "ProductDetails-module--productTitleSticky--a2948";
export var productToCartBtn = "ProductDetails-module--productToCartBtn--ab77d";
export var purseIconContainer = "ProductDetails-module--purseIconContainer--2e9e6";
export var qtyContainer = "ProductDetails-module--qtyContainer--1ba13";
export var qtyMinus = "ProductDetails-module--qtyMinus--b8c5b";
export var qtyPlus = "ProductDetails-module--qtyPlus--53b3a";
export var rateWrap = "ProductDetails-module--rateWrap--8f320";
export var rating = "ProductDetails-module--rating--803e5";
export var recommendations = "ProductDetails-module--recommendations--db989";
export var removeItemBtn = "ProductDetails-module--removeItemBtn--562a2";
export var reviewContainer = "ProductDetails-module--reviewContainer--8882b";
export var reviewInventoryCheck = "ProductDetails-module--reviewInventoryCheck--0a0b5";
export var reviewLink = "ProductDetails-module--reviewLink--1c6ed";
export var salePrice = "ProductDetails-module--salePrice--99c12";
export var savings = "ProductDetails-module--savings--a5e5a";
export var separator = "ProductDetails-module--separator--9aff7";
export var shippingBorder = "ProductDetails-module--shippingBorder--52c5f";
export var shippingOption = "ProductDetails-module--shippingOption--9e317";
export var shippingOptionsContainer = "ProductDetails-module--shippingOptionsContainer--43c9c";
export var shippingTitleContianer = "ProductDetails-module--shippingTitleContianer--31b8f";
export var show = "ProductDetails-module--show--dd790";
export var skuContainer = "ProductDetails-module--skuContainer--2adcd";
export var stickAddToCartContent = "ProductDetails-module--stickAddToCartContent--1e5f7";
export var stickAddToCartDetails = "ProductDetails-module--stickAddToCartDetails--b13e4";
export var stickyAddToCart = "ProductDetails-module--stickyAddToCart--af688";
export var stickyAddToCartImageContainer = "ProductDetails-module--stickyAddToCartImageContainer--99465";
export var stickyAddToCartLeft = "ProductDetails-module--stickyAddToCartLeft--4d023";
export var stickyAddToCartRight = "ProductDetails-module--stickyAddToCartRight--a643b";
export var stickyFooter = "ProductDetails-module--stickyFooter--8c474";
export var stickyFooterActive = "ProductDetails-module--stickyFooterActive--28f00";
export var stickyFooterButtonContainer = "ProductDetails-module--stickyFooterButtonContainer--92835";
export var stickyPaymentOptionContainer = "ProductDetails-module--stickyPaymentOptionContainer--723c3";
export var stickyTabContainer = "ProductDetails-module--stickyTabContainer--dd87b";
export var storeAddress = "ProductDetails-module--storeAddress--2b85d";
export var storeAvailability = "ProductDetails-module--storeAvailability--3f2d4";
export var storeDetail = "ProductDetails-module--storeDetail--22eb7";
export var storeName = "ProductDetails-module--storeName--e0a29";
export var storeTitle = "ProductDetails-module--storeTitle--7f08f";
export var swatch = "ProductDetails-module--swatch--f2ce2";
export var tabStickyContainer = "ProductDetails-module--tabStickyContainer--71e35";
export var titleContainer = "ProductDetails-module--titleContainer--94ea3";
export var truckIconContainer = "ProductDetails-module--truckIconContainer--a1c69";
export var variantOptions = "ProductDetails-module--variantOptions--4f9c1";
export var variantOptionsContainer = "ProductDetails-module--variantOptionsContainer--316df";
export var variantOptionsWrap = "ProductDetails-module--variantOptionsWrap--03422";
export var variantSwatches = "ProductDetails-module--variantSwatches--df490";
export var videoContainer = "ProductDetails-module--videoContainer--a740a";
export var warranty = "ProductDetails-module--warranty--36d11";
export var warrantyContainer = "ProductDetails-module--warrantyContainer--e9bec";
export var warrantyTitle = "ProductDetails-module--warrantyTitle--10bdb";
export var wishIconContainer = "ProductDetails-module--wishIconContainer--f23e0";
export var zipIconContainer = "ProductDetails-module--zipIconContainer--20b3b";
export var zipLogoContainer = "ProductDetails-module--zipLogoContainer--08c4e";